// extracted by mini-css-extract-plugin
module.exports = {"buttonCss":"IconButton_buttonCss__QQkzB","disabled":"IconButton_disabled__hV1vE","icon":"IconButton_icon__1TTCt"};